import React, { Fragment, useEffect, useState } from "react";
import { Container, Row, Col, Card, Nav } from "reactstrap";
import ModalFormSubmit from "../../../../share-components/form/modalFormSubmit";
import Breadcrumb from "../../../../layout/breadcrumb";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import withReducer from "../../../../store/withReducer";
import orderSettingReducer from "../store/store";
import CommonDataTable from "../../../../share-components/table/commonDataTable";
import {
  getOrderPaymentMethodSettings,
  openNewDialog,
  openEditDialog,
  closeEditDialog,
  storePaymentMethod,
  updatePaymentMethod,
  deletePaymentMethod,
} from "../store/paymentMethodSettingSlice";
import PaymentMethodSettingForm from "./paymentMethodForm";

const defaultValues = {
  id: "",
  name: "",
};
const dataMenu = [
  {
    type: 0,
    text: "Order",
    link: "/order",
  },
  {
    type: 1,
    text: "Order Setting",
    link: "",
  },
  {
    type: 1,
    text: "Payment Method",
    link: "",
  },
];
const schema = yup.object().shape({
  name: yup.string().required("This is required field"),
});
const PaymentMethod = () => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [isCreated, setIsCreated] = useState(false);
  const dispatch = useDispatch();
  const {
    handleSubmit,
    formState,
    reset,
    control,
    register,
    setValue,
    trigger,
    getValues,
  } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { errors } = formState;
  const closeDialog = () => {
    dispatch(closeEditDialog());
  };

  const onSubmitForm = (dialog, data) => {
    const formData = {
      id: data.id,
      name: data.name,
    };
    if (dialog.type === "new") {
      dispatch(storePaymentMethod({ ...formData })).then((res) => {
        if (!res.error) {
          setIsCreated(true);
          closeDialog(dialog.type);
        }
      });
    } else {
      dispatch(updatePaymentMethod({ ...formData })).then((res) => {
        if (!res.error) {
          closeDialog(dialog.type);
          setIsCreated(true);
        }
      });
    }
  };

  const onEdit = (row) => {
    dispatch(openEditDialog(row));
  };

  const onDelete = (row) => {
    dispatch(deletePaymentMethod(row.id));
    setIsCreated(true);
  };

  useEffect(() => {
    dispatch(getOrderPaymentMethodSettings()).then((res) => {
      console.log("Res ", res);
      setPaymentMethods(res.payload);
      setIsCreated(false);
    });
  }, [dispatch, isCreated]);

  const tableColumns = [
    {
      name: "Payment Method",
      selector: (row) => row.name,
      sortable: true,
      center: false,
    },
  ];

  return (
    <Fragment>
      <Container fluid className="">
        <Breadcrumb data={dataMenu} title="Payment Method" />
        <div>
          <div>
            <Row>
              <Col sm="12">
                <Card>
                  <Row>
                    <Col sm="6">
                      <Nav tabs className="border-tab"></Nav>
                    </Col>
                    <Col sm="6">
                      <div className="float-sm-right p-3">
                        <a
                          className="btn btn-sm btn-primary"
                          onClick={() => {
                            dispatch(openNewDialog());
                          }}
                        >
                          {" "}
                          <i className="fa fa-plus"></i> Add New Method
                        </a>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>

            <CommonDataTable
              headerColumns={tableColumns}
              gridData={paymentMethods}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          </div>
          
          <ModalFormSubmit
            defaultValues={defaultValues}
            schema={schema}
            formState={formState}
            handleSubmit={handleSubmit}
            onSubmitForm={onSubmitForm}
            noAction
            reset={reset}
            title="Payment Method"
            selector="orderSetting"
            dialog={({ paymentMethodSetting }) =>
              paymentMethodSetting.paymentMethodSetting.addDialog
            }
            closeDialog={closeDialog}
            setValue={setValue}
            getValues={getValues}
            btnText="Save"
          >
            <PaymentMethodSettingForm
              control={control}
              errors={errors}
              register={register}
              setValue={setValue}
              trigger={trigger}
              getValues={getValues}
            />
          </ModalFormSubmit>
        </div>
      </Container>
    </Fragment>
  );
};

export default withReducer([{ paymentMethodSetting: orderSettingReducer }])(
  PaymentMethod
);
